import React, { Fragment, useContext, useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import {
  FormsGlobalContext,
  SET_FAJITA_QUESTIONNAIRE_FORM,
} from '@mummssoftware/global-context';
import Typography from '@material-ui/core/Typography';
import { STRING_TRUE } from '@mummssoftware/utils/constants';
import { FajitaContext } from '../FajitaForms/Context';
import { ReqFieldDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.common.white,
    '&$checked': {
      color: theme.palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

export const ReadOnlyFormSwitch = () => {
  const { fajitaQuestionnaireFormGlobal, dispatchQuestionnaire } = useContext(
    FormsGlobalContext,
  );
  const formsGlobalContext = useContext(FormsGlobalContext);
  const { readOnlyFormSwitch } = useContext(FajitaContext);
  const [isPrintView, setPrintView] = useState<boolean>(false);

  const isReadOnly =
    fajitaQuestionnaireFormGlobal &&
    (fajitaQuestionnaireFormGlobal?.isPrintViewFAJITA ||
      fajitaQuestionnaireFormGlobal?.isReadOnlyViewFAJITA);

  const showSwitch =
    isReadOnly &&
    (fajitaQuestionnaireFormGlobal as any).formisreadonlyfullallowed ===
      STRING_TRUE &&
    readOnlyFormSwitch;

  useEffect(() => {
    if (!fajitaQuestionnaireFormGlobal) {
      // reset toggle
      setPrintView(false);
    }
  }, [fajitaQuestionnaireFormGlobal]);

  const handleReqChange = () => {
    if (formsGlobalContext) {
      if (isPrintView) {
        dispatchQuestionnaire({
          type: SET_FAJITA_QUESTIONNAIRE_FORM,
          payload: {
            ...fajitaQuestionnaireFormGlobal,
            isReadOnlyViewFAJITA: true,
            isPrintViewFAJITA: false,
            isInProgressFAJITA: false,
          },
        });
        setPrintView(false);
      } else {
        dispatchQuestionnaire({
          type: SET_FAJITA_QUESTIONNAIRE_FORM,
          payload: {
            ...fajitaQuestionnaireFormGlobal,
            isPrintViewFAJITA: true,
            isReadOnlyViewFAJITA: false,
            isInProgressFAJITA: false,
          },
        });
        setPrintView(true);
      }
    }
  };

  return (
    <Fragment>
      {showSwitch && (
        <Typography
          component="div"
          variant="body2"
          style={{ letterSpacing: 0 }}
        >
          <Grid component="div" container alignItems="center">
            <ReqFieldDiv>{defaults.readView}</ReqFieldDiv>
            <Grid item>
              <StyledSwitch
                checked={isPrintView}
                onChange={handleReqChange}
                name="checked"
              />
            </Grid>
            <ReqFieldDiv>{defaults.printView}</ReqFieldDiv>
          </Grid>
        </Typography>
      )}
    </Fragment>
  );
};
export default ReadOnlyFormSwitch;
